import styled from 'styled-components';

const SearchPageHolder = styled.div`
	grid-area: content;
	overflow: auto;
	width: 100%;
    margin: 0 auto;
	.headerText_container {
		@media screen and (max-width: 768px) {
			padding: 0 10px 0 10px;
		}
		.row {
			background-color: transparent !important;
		}
	}
	.entry-header {
		font-size: 0.8rem;
		background: #3c3f47;
		display: block;
		padding-right: 3rem;
		background-color: #726b55;
		min-height:50px;
	}
	
	.search-form-wrapper {
		background: transparent;
		margin-bottom: 0;
		padding: 5px 10px 10px;
		position: relative;
		.container--mid {
			max-width: 576px;
			margin: 0 auto;
			margin-bottom: 40px;
			margin-top: 40px;
			.search-form {
				background: transparent;
				margin-bottom: 0;
				.search-box {
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					position: relative;
					label {
						margin-right: auto;
						width: 100%;
						max-height: 48px;
					}
				}
				.search-filters {
					display: flex;
					justify-content: space-between;
					margin-top: 12px;
					flex-wrap: wrap;
					.custom-select {
						width: 48%;
					}
					select {
						font-size: 16px;
						font-weight: bold;
						width: 100%;
						border: 1px solid #a9b2b1;
						outline: 0;
						background-color: #fff;
						border-color: #a69e87;
						text-align: center;
						height: 40px;
						padding: 4px 10px 4px 10px;
						border-radius: 20px;
						transition: all 0.2s ease-in;
						vertical-align: middle;
						margin: 0 auto;
						color: #5f7586;
					}
				}
				input {
					font-size: 16px;
					font-weight: 400;
					width: 100%;
					margin-bottom: 1.6rem;
					border: 1px solid #a9b2b1;
					outline: 0;
					background-color: #fff;
					border-color: #a69e87;
					text-align: left;
					height: 40px;
					padding: 4px 85px 4px 10px;
					border-radius: 2em;
					transition: all 0.2s ease-in;
					vertical-align: middle;
					margin: 0 auto;
					color: #5f7586 !important;
					&::placeholder {
						font-weight: 600;
					}
					&:focus {
						text-align: left;
					}
				}
				button {
					color: #fdfdfc;
					background: #726b55 !important;
					border: solid 5px #d1cdc1 !important;
					transition: all 0.2s ease-in;
					position: absolute;
					top: 5px;
					right: 6px;
					border-radius: 2em;
					vertical-align: middle;
					line-height: 1.1;
					padding: 4px 10px;
					padding: 4px 10px;
					font-size: 12px;
					text-transform: uppercase;
					cursor: pointer;
					&:hover {
						background: #a69e87 !important;
						border: solid 5px #a69e87 !important;
						transition: all 0.2s ease-in;
					}
				}
			}
		}
	}
	.container-result-wrap {
		.result-container {
			padding: 0 8px;
			max-width: 720px;
			margin: 0 auto 8px auto;
			border-top: 1px solid #a69e87;
			.list-main {
				list-style: none;
				margin-top: 0;
				padding: 0;
				.list-main__item {
					position: relative;
					border-bottom: 1px solid #a69e87;
					display: flex;
					flex-wrap: wrap;
					padding: 20px 0;
					width: 100%;
					justify-content: center;
					svg {
						font-size: 20px;
						color: #a69e87;
						position: absolute;
						top: 3px;
						right: 0;
						cursor: help;
					}
					.list-main__image {
						flex: 0 0 36%;
						width: 100%;
						margin-right: 20px;
						max-width: 268px;
						position: relative;
						max-height: 150px;
						min-height: 150px;
						img {
							max-width: 100%;
							height: auto;
							min-width: 268px;
							max-height: 150px;
							min-height: 150px;
						}
						span {
							content: '00:00:00';
							background-color: rgba(0, 0, 0, 0.6);
							padding: 4px;
							display: block;
							position: absolute;
							bottom: 0;
							right: 0;
							color: white;
							font-family: "Quicksand", sans-serif;
							font-size: 14px;
						}
						@media screen and (max-width: 768px) {
							flex: 0 0 100%;
							margin-right: 0px;
							max-width: 100%;
							max-height: 100%;
							img {
								width: 100%;
								max-height: 100%;
							}
						}
					}
					.list-main__content {
						flex: 0 0 56%;
						width: 100%;
						.description_text {
							margin-top: 8px;
							font-weight: 500;
							font-size: 17px;
							color: #383838;
							line-height: 1.5em;
							cursor: pointer;
							.description__ellipsis {
								color: #7a7652;
								text-shadow: none;
								cursor: pointer;
								margin-left: 5px;
								&:hover {
									color: #606060;
								}
							}
						}
						.featured-container__small-item {
							p {
								margin: 0;
								font-size: 18px;
							}
						}
						.featured-container__small-item-category {
							text-decoration: none;
							padding-bottom: 14px;
							p {
								margin: 0;
								padding: 0;
								color: #5f7586;
								font-size: 12px !important;
								text-transform: uppercase;
								margin-bottom: 4px;
								font-weight: bold;
							}
						}
						.list-main__title {
							margin: 0px;
							font-weight: 400;
							font-size: 1.6rem;
							.featured-container__small-item {
								text-decoration: none;
								color: #7a7652;
								p {
									margin: 0px;
								}
							}
						}
						@media screen and (max-width: 768px) {
							flex: 0 0 100%;
						}
					}
				}
			}
		}
	}
	.pagination__control {
		margin-bottom: 10px;
		display: flex;
		justify-content: center;
		button {
			font-weight: 700;
			padding: 12px 20px;
			vertical-align: middle;
			font-size: 14px;
			color: #726b55;
			background-color: #fdfdfc;
			border-radius: 4px;
			transition: all 0.1s ease-in;
			border: 1px solid #d1cdc1;
			line-height: 1;
			transition: all 0.1s ease-in;
			margin-right: 10px;
			min-height: 48px;
			cursor: pointer;
			svg {
				padding: 0;
				margin: -2px 8px 0 8px;
				vertical-align: middle;
				line-height: 1;
			}
			&:disabled {
				opacity: 0.4;
				cursor: no-drop;
			}
			&:hover {
				background-color: #a69e87 !important;
				color: #fdfdfc !important;
				transition: all 0.1s ease-in;
			}
		}
	}
`;

export default SearchPageHolder;